/**
 * This file consolidates seo logic within website/shared
 *
 * suggestion: If we need to share this logic with other apps/projects we
 *             should move this logic to the @outschool/text package
 */
import { cleanUrlTerm } from "@outschool/routes";
import { compact, startCase, uniq } from "lodash";

import {
  DEFAULT_SUBJECTS,
  DEFAULT_SUBJECTS_LIST_VERSION
} from "./constants/subjects";
import { Subject } from "./types";

export function isTermWithinSubjectList(
  term: string,
  version = DEFAULT_SUBJECTS_LIST_VERSION
): boolean {
  return fetchSubjects(version).includes(cleanUrlTerm(term));
}

export function fetchSubjects(
  version = DEFAULT_SUBJECTS_LIST_VERSION
): string[] {
  return cleanSubjectTerms(DEFAULT_SUBJECTS[version]);
}

export function niceSubjectTerm(subject: string): string {
  return startCase(cleanUrlTerm(subject)).replace("And", "&");
}

function cleanSubjectTerms(subjectList: Subject[]): string[] {
  return compact(
    uniq(
      subjectList.map((subject: Subject) => {
        return cleanUrlTerm(subject.slug);
      })
    )
  ).sort();
}

// note: no trailing slash for online classes but it is also a root url that can contain search query parameters
const allowedNoIndexPaths = [
  "/classes/",
  "/online-classes",
  "/teachers/",
  "/users/login"
];
export function shouldServeNoIndex({
  host = "",
  urlPath,
  hasSearchQuery,
  osAgent = ""
}: {
  host?: string;
  urlPath: string;
  hasSearchQuery: boolean;
  osAgent?: string;
}): boolean {
  if (host === "website.app.outschool.com" && !osAgent.includes("Outschool")) {
    return true;
  }

  // then check if the urlPath is allowed
  if (
    !urlPath ||
    !allowedNoIndexPaths.some((allowedPath: string) =>
      urlPath.startsWith(allowedPath)
    )
  ) {
    return false;
  }

  // if any search params are present then show noindex
  if (hasSearchQuery) {
    return true;
    // if /enroll is present within a class url
  } else if (urlPath.includes("/classes/") && urlPath.includes("/enroll")) {
    return true;
  }

  return false;
}
